import { Component, OnInit } from '@angular/core';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { DateRangePipe } from 'src/app/tools/pipes/date-range-pipe';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { WarehouseTransfer } from 'src/app/assabil-sales/models/entities/warehouse-transfer';
import { WarehouseTransferType } from 'src/app/assabil-sales/enums/warehouse-transfer-type';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { WarehouseService } from 'src/app/assabil-sales/services/warehouse-service';
import { WarehouseTransferLine } from 'src/app/assabil-sales/models/entities/warehouse-transfer-line';
import { ActivatedRoute } from '@angular/router';
import { SalesReportsService } from 'src/app/assabil-sales/services/sales-reports-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { WarehouseTransferReason } from 'src/app/assabil-kernel/models/entities/control-tables/warehouse-transfer-reason';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';

@Component({
  selector: 'warehouse-inout',
  templateUrl: './warehouse-inout.component.html',
  styleUrls: ['./warehouse-inout.component.scss']
})
export class WarehouseInOutComponent implements OnInit {

  enteredOnly    : boolean       = false;
  returnWt       : boolean       = false;
  purpose        : string;
  purposes       = [];
   
  qColumns  = [
    {'label' : 'Quantité',   readOnly : false, background :'#eef5fb'}, 
  ];

  
  constructor(
    protected baseService       : BaseService,
    public    masterDataService : MasterDataService,
    protected warehouseService  : WarehouseService,
    protected location          : Location,
    protected toastr            : ToastrService,
    protected leanUtilsService  : LeanUtilsService,
    protected activatedRoute    : ActivatedRoute,
    protected dateRangePipe     : DateRangePipe,
    protected controlService    : ControlTablesService,
    protected salesReportsService : SalesReportsService) {
    }


      
//-----------------------------------------------------------------------------------------------------------------------------
productCode   : string;
salableOnly   : boolean = true;
includingHold : boolean = false;

warehouseTransferCreated   : WarehouseTransfer;

ngOnInit() {
  this.masterDataService.loadProductPages(1, true);
  this.activatedRoute.data.subscribe(data => {
    this.returnWt = data['returnWt'];

    if (this.returnWt) {
      this.initControlTables("OUT");
    } else {
      this.initControlTables("IN");
    }
  });
}
//-----------------------------------------------------------------------------------------------------------------------------

//-----------------------------------------------------------------------------------------------------------------------------
warehouseTransferReasons                   : WarehouseTransferReason[];
initControlTables(warehouseTransferReasonType : string){
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = warehouseTransferReasonType;
    this.controlService.getList("warehouseTransferReason", request).then(result => { 
        this.warehouseTransferReasons = result;
    });
}
//-----------------------------------------------------------------------------------------------------------------------------



//-----------------------------------------------------------------------------------------------------------------------------
validate(){
  if (this.purpose == null) {
    this.toastr.error("Prière de préciser la raison du mouvement de stock");
    return;
  }
  let warehouseTransfer : WarehouseTransfer = this.buildWarehouseTransfer();
  if ( (warehouseTransfer.warehouseTransferLines == null)  || (warehouseTransfer.warehouseTransferLines.length == 0)) {
    this.toastr.error("Aucune quantité de produit n'a été saisie");
    return;
  }
  this.warehouseService.warehouseTransferAssign(warehouseTransfer).then(result => {
    this.warehouseTransferCreated = result;
    this.leanUtilsService.success();
    this.masterDataService.loadProductPages(1, true);
    this.purpose = null;
  })
}
//-----------------------------------------------------------------------------------------------------------------------------

//-----------------------------------------------------------------------------------------------------------------------------
 close(){
  this.location.back();
 }
//-----------------------------------------------------------------------------------------------------------------------------



//-----------------------------------------------------------------------------------------------------------------------------
buildWarehouseTransfer() : WarehouseTransfer{
 let warehouseTransfer : WarehouseTransfer = new WarehouseTransfer();
  warehouseTransfer                  = new WarehouseTransfer();
  warehouseTransfer.requestedForRole = new Role();
  warehouseTransfer.confirmedByRole  = new Role();
  warehouseTransfer.transferType     = WarehouseTransferType.tt_direct;
  warehouseTransfer.progressLevel    = 10;           // submited to warehouse keeper  
  warehouseTransfer.returnWt         = this.returnWt;
  warehouseTransfer.userField1       = this.purpose;
  warehouseTransfer.inserted         = true;
  
  warehouseTransfer.warehouseTransferRequests = [];
  this.masterDataService.salableProductPages.forEach(pp => {
      pp.products.forEach(product => {
          if (product.quantityL[0] || product.quantityP[0] || product.quantityU[0]) {
              let warehouseTransferLine : WarehouseTransferLine = new WarehouseTransferLine();
              warehouseTransferLine.inserted            = true;
              warehouseTransferLine.product             = new Product();
              warehouseTransferLine.product.productCode = product.productCode;
              warehouseTransferLine.product.name        = product.name;
              warehouseTransferLine.productBatchCode    = "?"
              if (! this.returnWt) {
                warehouseTransferLine.quantity            = this.getQuantity(product, 0); 
              } else {
                warehouseTransferLine.returnedQuantity    = this.getQuantity(product, 0); 
              }
              warehouseTransfer.warehouseTransferLines.push(warehouseTransferLine);
              //warehouseTransferLine.returnedQuantity         = this.getQuantity(product, 0);
              //warehouseTransferLine.returnedDamagedQuantity1 = this.getQuantity(product, 1);
              //warehouseTransferLine.returnedDamagedQuantity2 = this.getQuantity(product, 2); 

          }
      })
  })
  return warehouseTransfer;
}
//-----------------------------------------------------------------------------------------------------------------------------

  //------------------------------------------------------------------------------------------------------------
  getQuantity(product: Product, index: number): number {
    let res = (this.leanUtilsService.nullToZero(product.quantityL[index]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[index]) * product.loadPacking) + this.leanUtilsService.nullToZero(product.quantityU[index]);
    return res;
  }
  //------------------------------------------------------------------------------------------------------------

  //---------------------------------------------------------------------------------------
  print(){
    this.salesReportsService.warehouseTransferPrint(this.warehouseTransferCreated.warehouseTransferCode);
  }
  //---------------------------------------------------------------------------------------
  
}
